import { handleImageErrorProfile } from "../../../utils/UtilsFiles";

export const IntroductionAdminColumns = [
    {
        key: 'id',
        label: 'ID',
        width: '20%',
        getValue: (u: any) => <>#{u.id}</>
    },
    {
        key: 'requester',
        label: 'REQUESTER',
        width: '40%',
        getValue: (u: any) => (
            <div className="introduction-admin-author-meta">
                <img src={u.requester.avatar} alt={u.requester.username} onError={handleImageErrorProfile} />
                <span>{u.requester.username}</span>
                <div className="tier">
                    <span>{u.requester.tier || 'N/A'}</span>
                </div>
            </div>
        )
    },
    {
        key: 'recipent',
        label: 'RECIPENT',
        width: '40%',
        getValue: (u: any) => (
            <div className="introduction-admin-author-meta">
                <img src={u.recipent.avatar} alt={u.recipent.username} onError={handleImageErrorProfile} />
                <span>{u.recipent.username}</span>
                <div className="tier">
                    <span>{u.recipent.tier || 'N/A'}</span>
                </div>
            </div>
        )
    },
    {
        key: 'dateRequest',
        label: 'DATE REQUESTED',
        width: '40%',
        isDate: true
    },
    {
        key: 'status',
        label: 'STATUS',
        width: '40%'
    }
]